import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Login.css";

const API_BASE = "/api";

/*
 * Opened from an invite or reset link: /set-password#<token>. The token
 * is read once and removed from the address bar.
 */
function SetPassword() {
  const [token] = useState(() => window.location.hash.slice(1));
  const [link, setLink] = useState(null);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    window.history.replaceState(null, "", window.location.pathname);

    if (!token) {
      setError("This link is incomplete. Ask your administrator for a new one.");
      setLoading(false);
      return;
    }

    axios
      .post(`${API_BASE}/auth/link`, { token })
      .then((response) => setLink(response.data))
      .catch((err) =>
        setError(err.response?.data?.error || "Unable to open this link.")
      )
      .finally(() => setLoading(false));
  }, [token]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (password.length < 12) {
      setError("Use at least 12 characters.");
      return;
    }

    if (password !== confirm) {
      setError("The two passwords don't match.");
      return;
    }

    setSubmitting(true);
    setError("");

    try {
      await axios.post(`${API_BASE}/auth/link/password`, { token, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || "Unable to set the password.");
    } finally {
      setSubmitting(false);
    }
  };

  const goToSignIn = () => {
    window.location.assign("/");
  };

  return (
    <main className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <h1 className="login-logo">
          <img src="/reachlink-logo.png" alt="ReachLink" />
        </h1>
        <p>Business texting by 10 Digits</p>

        {loading ? (
          <p className="login-help">Checking your link...</p>
        ) : done ? (
          <>
            <div className="login-success">
              Your password is set. Sign in with {link.email}.
            </div>
            <button type="button" onClick={goToSignIn}>
              Go to sign in
            </button>
          </>
        ) : !link ? (
          <>
            <div className="login-error">{error}</div>
            <button type="button" onClick={goToSignIn}>
              Go to sign in
            </button>
          </>
        ) : (
          <>
            <p className="login-help">
              {link.purpose === "invite"
                ? `Welcome${link.firstName ? `, ${link.firstName}` : ""}. Choose a password for ${link.email}.`
                : `Choose a new password for ${link.email}.`}
            </p>

            {error && <div className="login-error">{error}</div>}

            <input type="email" value={link.email} autoComplete="username" readOnly hidden />

            <label htmlFor="new-password">New password (12 or more characters)</label>
            <input
              id="new-password"
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              disabled={submitting}
              maxLength="128"
            />

            <label htmlFor="confirm-password">Type it again</label>
            <input
              id="confirm-password"
              type="password"
              autoComplete="new-password"
              value={confirm}
              onChange={(event) => setConfirm(event.target.value)}
              disabled={submitting}
              maxLength="128"
            />

            <button type="submit" disabled={submitting}>
              {submitting ? "Saving..." : "Set password"}
            </button>
          </>
        )}
      </form>
    </main>
  );
}

export default SetPassword;
